import { SecurityHardCodePricePayload } from '@repo/types';

export type SecurityListItem = {
  id: number;
  bloombergCode: string;
  currency: string;
  isin: string;
  market: string;
  ricCode: string;
  securityName: string;
  securitySubtype: string;
  securityType: string;
};

export enum SecurityType {
  Cash = 337,
  Equity = 334,
  EquityCFD = 335,
  FixedIncome = 336,
  Fund = 372,
  Futures = 339,
  Index = 496,
  Option = 338,
  StructuredProduct = 1725,
}

export enum SecuritySubType {
  CashWithdrawal = 340,
  CashDeposit = 341,
  ForwardFXContract = 1655,
}

export type SecurityParameters = {
  currency: SecurityParameter[];
  exchange: SecurityParameter[];
  market: SecurityParameter[];
  optionType: SecurityParameter[];
  securitySubType: Record<SecurityType, SecurityParameter[]>;
  securityType: SecurityParameter[];
  settlementCenter: SecurityParameter[];
  gicsIndustry: Record<number, SecurityParameter[]>;
  gicsIndustryGroup: Record<number, SecurityParameter[]>;
  gicsSector: SecurityParameter[];
  isoSector5: SecurityParameter[];
  msciMarket: SecurityParameter[];
  underlyingId: SecurityParameter[];
  futuresContract: SecurityParameter[];
  marketIssueType: SecurityParameter[];
  fundType: SecurityParameter[];
  securityStatus: SecurityParameter[];
};

export type SecurityParameter = {
  id: number;
  value: string;
};

export type SecurityDetail = {
  id: number;
  currency: number;
  fromCcy?: number;
  toCcy?: number;
  exchange: number;
  mifidExchange: number;
  optionType: number;
  securityType: number;
  securitySubtype: number;
  settlementCenter: number;
  market: number;
  marketIssueType: number;
  isin: string;
  cusip: string;
  sedol: string;
  bloombergCode: string;
  ricCode: string;
  securityName: string;
  identifier1: string;
  identifier2: string;
  identifier3: string;
  identifier4: string;
  identifier5: string;
  futuresContract: number;
  issueDate: string;
  couponFrequency: string;
  couponRate: string;
  strikePrice: string;
  expiryDate: string;
  underlyingId: number;
  multiplier: string;
  securityStatus: number;
  countryOfIssue: string;
  listedProduct: boolean;
  fundType?: string;
  oecd: boolean;
  issuer: string;
  gicsSector: number;
  gicsIndustryGroup: number;
  gicsIndustry: number;
  mifidTransactionFlag: boolean;
  mifidCfiCode: string;
  createdBy: string;
  updatedBy: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  msciMarket: number;
  isoSector5: number;
  frequency?: SecurityFrequency;
  observationDate?: string;
  nextCouponDate?: string;
};

export enum SecurityFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnually = 'Semi-Annually',
  Annually = 'Annually',
}

export type SecurityListShortItem = {
  bloombergCode: string;
  id: number;
  isin: string;
  securityName: string;
  multiplier: string;
  currency: number;
};

export type SecurityDetailWithHardCodePrice = SecurityDetail & {
  hardCodePrice: SecurityHardCodePricePayload[];
};
